<template>
  <section class="dd-crypto">
    <div class="dd-wall-card dd-crypto__card">
      <header class="dd-crypto__header">
        <h2 class="dd-crypto__title">
          {{ $t('crypto_payment.transfer_using_the_following_details', { currency: currencySymbol }) }}
        </h2>
        <p v-if="!donationOnlyMode" class="dd-crypto__subtitle">
          {{ $t('crypto_payment.your_effect_will_appear_on_the_stream_after_one_confirmation') }}
        </p>
      </header>

      <div class="dd-crypto__grid">
        <div class="dd-crypto__col">
          <div class="dd-crypto__field" @click="copyAmount">
            <label class="dd-crypto__label">{{ $t('crypto_payment.amount') }}</label>
            <div class="dd-crypto__input-group">
              <input
                ref="inputAmount"
                type="text"
                class="form-control dd-crypto__input"
                :value="amount || ''"
                readonly
              />
            </div>
            <span v-if="amountCopied" class="dd-crypto__copied">{{ $t('crypto_payment.amount_copied') }}</span>
          </div>

          <div class="dd-crypto__field" @click="copyAddress">
            <label class="dd-crypto__label">{{ $t('crypto_payment.to_the_address') }}</label>
            <div class="dd-crypto__input-group">
              <input
                ref="inputAddress"
                type="text"
                class="form-control dd-crypto__input"
                :value="address || ''"
                readonly
              />
            </div>
            <span v-if="addressCopied" class="dd-crypto__copied">{{ $t('crypto_payment.address_copied') }}</span>
          </div>

          <div class="dd-crypto__qr" v-if="qrCode">
            <img :src="qrCode" alt="QR code" />
          </div>
        </div>

        <div class="dd-crypto__col">
          <div class="dd-crypto__wallet" v-if="paymentURL">
            <div class="dd-crypto__note">{{ $t('crypto_payment.if_you_have_the_wallet_app_installed', { currency: currencySymbol }) }}</div>
            <a :href="paymentURL" class="btn-orange">{{ $t('crypto_payment.pay_in_the_app') }}</a>
          </div>

          <div class="dd-crypto__status">
            <span class="dd-pill">{{ statusLabel }}</span>
          </div>

          <div class="dd-crypto__description" v-if="effectGenerationSession">
            <span v-html="generationRedirectHtml"></span>
          </div>

          <div class="dd-crypto__footer">
            <button type="button" class="dd-crypto__back" @click="closePanel">{{ $t('crypto_payment.go_back') }}</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {logWarn, logError} from '@/helpers';

export default {
  name: 'CryptoPaymentPanel',
  data() {
    return {
      amountCopied: false,
      addressCopied: false,
      copyTimers: [],
    };
  },
  computed: {
    currencySymbol() {
      return this.$store.getters.selectedCryptoCurrencySymbol || '';
    },
    amount() {
      return this.$store.getters.amount;
    },
    address() {
      return this.$store.getters.paymentAddress;
    },
    qrCode() {
      return this.$store.getters.paymentQRCode;
    },
    paymentURL() {
      return this.$store.getters.paymentURL;
    },
    donationOnlyMode() {
      return this.$store.getters.donationOnlyMode;
    },
    effectGenerationSession() {
      return this.$store.getters.effectGenerationSession;
    },
    statusLabel() {
      const mode = this.$store.getters.cryptocurrencyPaymentMode;
      if (mode === 'awaiting_confirmation') {
        return this.$t('crypto_payment.awaiting_confirmation');
      }
      return this.$t('crypto_payment.awaiting_payment');
    },
    generationRedirectHtml() {
      if (!this.effectGenerationSession) {
        return '';
      }
      const path = `/wall/generate?session=${this.effectGenerationSession.uuid}`;
      return this.$t('crypto_payment.we_will_redirect_you_to_the_sticker_creation_page', { href: path });
    },
  },
  methods: {
    copyAmount() {
      this.copyToClipboard(this.amount, 'amountCopied', 'inputAmount');
    },
    copyAddress() {
      this.copyToClipboard(this.address, 'addressCopied', 'inputAddress');
    },
    closePanel() {
      this.$router.push('/wall/effects');
    },
    copyToClipboard(value, flag, refName) {
      if (!value) {
        return;
      }
      const input = this.$refs[refName];
      if (input) {
        try {
          input.focus({ preventScroll: true });
        } catch (e) {
          logWarn('Failed to focus input before clipboard copy', e);
        }
        try {
          input.select();
        } catch (e) {
          logWarn('Failed to select input text before clipboard copy', e);
        }
      }
      const clipboard = typeof navigator !== 'undefined' ? navigator.clipboard : null;
      if (clipboard && typeof clipboard.writeText === 'function') {
        clipboard.writeText(value).catch((err) => {
          logWarn('Clipboard API copy failed, falling back to execCommand', err);
          try {
            document.execCommand('copy');
          } catch (e) {
            logError('Fallback execCommand copy failed', e);
          }
        });
      } else {
        try {
          document.execCommand('copy');
        } catch (e) {
          logError('execCommand copy is not supported in this browser', e);
        }
      }
      this[flag] = true;
      const timer = setTimeout(() => {
        this[flag] = false;
      }, 2000);
      this.copyTimers.push(timer);
    },
  },
  beforeDestroy() {
    this.copyTimers.forEach(clearTimeout);
  },
};
</script>
